/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {EnumValue} from "../model/enum-value";

@Injectable({
    providedIn: "root",
})
export class SimEnumService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
/**
 * See: https://www.codingame.com/playgrounds/2487/c---how-to-display-friendly-names-for-enumerations
 */ 

    public getDescription(genericEnum: string | number) {
        return super.get<string>(`/api/Enum/GetDescription`, {genericEnum: genericEnum});
    }
/**
 * Method returns all enum values
 */ 

    public getEnumByName(enumName: string) {
        return super.get<EnumValue[]>(`/api/Enum/GetEnumByName`, {enumName: enumName});
    }
/**
 * Lists Enums in SimStation.BO.dll
 */ 

    public getEnums() {
        return super.get<string[]>(`/api/Enum/GetEnums`, );
    }
}